export default __webpack_public_path__ + "static/media/regulatory--night-speed-limit-30--g1.de686fba.png";